import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiStatus } from '@App/constant/centax-app.constant';
import { ContactService } from "@App/miscellaneous/contact-us-form/services/contact-us-form.service";
import { LogoHeaderModule } from "../../modules/header/logo-header/logo-header.module";
import { CommonModule } from '@angular/common';
import { CommonAlertService } from '@App/services/common-alert.service';
import { CentaxHeaderModule } from '@App/modules/header/header.module';
import { HomeService } from '@Services/home.service';
import { AppUtilityService } from '@Utils/app-utlility.service'

@Component({
  selector: 'app-contact-us-form',
  standalone: true,
  imports: [ReactiveFormsModule, LogoHeaderModule, CommonModule, CentaxHeaderModule],
  templateUrl: './contact-us-form.component.html',
  styleUrls: ['./contact-us-form.component.scss'],
})
export class ContactUsFormComponent implements OnInit {
  contactForm: FormGroup;
  states = [];
  isSubmitted=false
  cities: string[] = [];
  stateFromPincode = false;
  cityFromPincode = false;
  formSubmitted = false;
  minDate: string;

  constructor(private fb: FormBuilder, private contact: ContactService, private commonAlertService: CommonAlertService, private homeService: HomeService, private appUtility: AppUtilityService) {

    // const today = new Date();
    // const isoString = today.toISOString(); // e.g., 2025-04-16T12:49:38.123Z
    
    // // Convert to local datetime without seconds (e.g., 2025-04-16T18:19)
    // const localDate = new Date(today.getTime() - today.getTimezoneOffset() * 60000)
    //   .toISOString()
    //   .slice(0, 16); // Remove seconds and 'Z'
    
    // this.minDate = localDate;
    

    this.contactForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.pattern(/^[a-zA-Z\s]*$/), Validators.maxLength(20)]],
      lastName: ['', [Validators.required, Validators.pattern(/^[a-zA-Z\s]*$/), Validators.maxLength(20)]],
      mobileNumber: ['', [
        Validators.required, 
        Validators.pattern(/^[6-9]\d{9}$/),
        Validators.minLength(10),
        Validators.maxLength(10)
      ]],
      email: ['', [
        Validators.required, 
        Validators.email,
        Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),
        Validators.maxLength(35)
      ]],
      pinCode: ['', [
        Validators.required, 
        Validators.pattern(/^(?!000000$)[0-9]{6}$/),
        Validators.minLength(6),
        Validators.maxLength(6)
      ]],
      state: [{value: '', disabled: true}, [Validators.required, Validators.maxLength(20)]],
      city: [{value: '', disabled: true}, [Validators.required, Validators.maxLength(20)]],
      // scheduleCall: [''],
      message: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.homeService.showHeader.next(true);
    this.homeService.showSidebarPage.next(false);
    this.contactForm.get('pinCode')?.valueChanges.subscribe((value: string) => {
      if (value && value.length == 6) {
        // console.log("PIN entered:", value);
        this.getStateAndCity(value);
      } else {
        // Reset state and city fields when pincode is cleared or invalid
        this.resetStateCity();
      }
    });
  }
  
  resetStateCity() {
    // Keep fields disabled but clear values
    this.contactForm.get('state')?.setValue('');
    this.contactForm.get('city')?.setValue('');
    this.contactForm.get('state')?.disable();
    this.contactForm.get('city')?.disable();
    this.stateFromPincode = false;
    this.cityFromPincode = false;
  }

  getStateAndCity(pin: string) {
    const pinCode = parseInt(pin);
    
    this.contact.getStateAndCity(pinCode).subscribe(
      (res) => {
        const data = res.Data;
        // console.log("API response:", data);

        if (data?.StateName) {
          // Set state value and keep it disabled
          this.contactForm.get('state')?.setValue(data.StateName);
          this.contactForm.get('state')?.disable();
          this.stateFromPincode = true;
        } else {
          // Enable state field if no state is returned
          this.contactForm.get('state')?.enable();
          this.stateFromPincode = false;
        }

        if (data?.DistrictName) {
          // Set city value and keep it disabled
          this.contactForm.get('city')?.setValue(data.DistrictName);
          this.contactForm.get('city')?.disable();
          this.cityFromPincode = true;
        } else {
          // Enable city field if no city is returned
          this.contactForm.get('city')?.enable();
          this.contactForm.get('city')?.setValue('');
          this.cityFromPincode = false;
        }
      }, 
      (err) => {
        console.error("Error fetching state/city:", err);
        // Enable both fields on error
        this.contactForm.get('state')?.enable();
        this.contactForm.get('city')?.enable();
        this.stateFromPincode = false;
        this.cityFromPincode = false;
      }
    );
  }

  generateLead(dataSource: any): void {
		this.appUtility.createDefaultUtmInfoSite();
		const data:any = {
			fName: dataSource?.firstName,
			LName: dataSource?.lastName,
			eMailID: dataSource?.email,
			sCity: dataSource?.city,
			sState: dataSource?.state,
			sMobileNo: dataSource?.mobileNumber
		}
		const finalData = this.appUtility.setCRMData(data, 'CONTACT_US');
		this.homeService.pushUtmSourceInformation('Lead for enquiry from Contact Us Page', true, 'CRM', finalData, 'CONTACT_US');
	}

  onSubmit() {
    if (this.contactForm.valid) {
      // console.log('Form Submitted:', this.contactForm.getRawValue());

      // Create a payload that includes values from disabled fields
      const formData = this.contactForm.getRawValue();

      this.contact.contactUs(formData).subscribe(
        (res) => {
          const data = res.Data;
          // console.log("Submitted Response:", data);
          this.formSubmitted = true;
          this.commonAlertService.successToast(res.StatusMsg);
          this.generateLead(formData);
          this.contactForm.reset();
          this.resetStateCity(); // Reset and disable state/city fields
        }, 
        (err) => {
          console.error("Submission Error:", err);
        }
      );
    } else {
      this.contactForm.markAllAsTouched();
    }
  }
}